<div class="me-2" [attr.aria-label]="showAria ? t('app.loader') : null" *transloco="let t">
   <span [style]="{'height': height, 'width': height}" class="loader"></span>
</div>